import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {ScheduleTrackerReducerState} from './stateTypes';

const initialState: ScheduleTrackerReducerState = {
    scheduleTrackerRequestsCount: 0,
};

const SLICE_NAME = 'commonScheduleTrackerReducer';
const {actions, reducer} = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {
        updateScheduleTrackerRequestsCount: (state, action: PayloadAction<number>) => {
            state.scheduleTrackerRequestsCount = action.payload;
        },
        getScheduleTrackerRequestsCount: (state) => state,
        getScheduleTrackerRequestsCountSuccess: (state, action: PayloadAction<number>) => {
            state.scheduleTrackerRequestsCount = action.payload;
        },
        getScheduleTrackerRequestsCountError: (state) => {
            state.scheduleTrackerRequestsCount = 0;
        },
    },
});

export const {
    updateScheduleTrackerRequestsCount,
    getScheduleTrackerRequestsCount,
    getScheduleTrackerRequestsCountSuccess,
    getScheduleTrackerRequestsCountError,
} = actions;

export default reducer;
